import { MENU_TITLE_STATE_KEY } from "../../utils/dynamicMenu";

const NAVIGATION_STATE_KEYS = new Set([MENU_TITLE_STATE_KEY]);

export function screenParams(location) {
  const params = {};
  const search = new URLSearchParams((location && location.search) || "");
  search.forEach((value, key) => {
    params[key] = value;
  });
  const state = location && location.state;
  if (state && typeof state === "object" && !Array.isArray(state)) {
    Object.keys(state).forEach(key => {
      if (NAVIGATION_STATE_KEYS.has(key) || state[key] == null) return;
      params[key] = state[key];
    });
  }
  return params;
}

export function stageCodeMatchesPrefix(stageCode, prefix) {
  const code = String(stageCode == null ? "" : stageCode).trim();
  const normalizedPrefix = String(prefix == null ? "" : prefix).trim();
  if (!code || !normalizedPrefix) return false;
  return code.startsWith(normalizedPrefix);
}

export function filterGradesByStagePrefix(grades, prefix) {
  const source = grades || {};
  const columns = (source.columns || []).filter(column =>
    stageCodeMatchesPrefix(column.CODETAPA, prefix)
  );
  const groupNames = new Set(
    columns.map(column => column.group).filter(Boolean)
  );
  const groups = (source.groups || []).filter(group =>
    groupNames.has(group.name)
  );
  return {
    ...source,
    columns,
    groups
  };
}

export function gridHasEvaluations(grades) {
  return Boolean(grades && grades.columns && grades.columns.length);
}

export function hidesNewEvaluation(config) {
  return Boolean(config && config.hideEvaluation === true);
}

export function isTemplateButtonVisible(button, status) {
  const show = button && button.show;
  if (!show || show.gridHasValue == null) return true;
  if (!status || !status.searched) return false;
  return show.gridHasValue === true
    ? Boolean(status.hasEvaluations)
    : !status.hasEvaluations;
}
